module.exports = __webpack_public_path__ + "img/28wnZrx-S9SGkbz30xcUwg.10883321.svg";